export default __webpack_public_path__ + "static/media/select-arrow.da797a9f.svg";